import React, { createContext, useContext, useEffect, useState } from 'react';
import { Lang, Translation, translations } from './translations';
interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Translation;
}
const STORAGE_KEY = 'lkhv_lang';
const LanguageContext = createContext<LanguageContextValue>({
  lang: 'cs',
  setLang: () => {},
  t: translations.cs
});
function readStoredLang(): Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'cs' || stored === 'en' || stored === 'de') return stored;
  } catch {
    /* private mode — ignore */
  }
  return 'cs';
}
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>(readStoredLang);
  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* ignore */
    }
  }, [lang]);
  const setLang = (next: Lang) => setLangState(next);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-509" data-mp="30yminpqtf3u5">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  return useContext(LanguageContext);
}